var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoursePlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 58,
    viewBox: "0 0 63 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.19964C0.012 1.43889 1.40352 0.0139937 3.1248 0H59.8752C61.6014 0 63 1.43386 63 3.19964V54.8004C62.988 56.5611 61.5965 57.986 59.8752 58H3.1248C1.3986 57.9983 0 56.5663 0 54.8004V3.19964ZM56.7004 6.44457H6.30036V51.5557L35.5702 21.6083C36.8003 20.3504 38.7942 20.3504 40.0243 21.6083L56.7004 38.6989V6.44457ZM12.5996 19.3332C12.5996 22.8924 15.4202 25.7777 18.8996 25.7777C22.379 25.7777 25.1996 22.8924 25.1996 19.3332C25.1996 15.774 22.379 12.8888 18.8996 12.8888C15.4202 12.8888 12.5996 15.774 12.5996 19.3332Z",
    fill: "#006DBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursePlaceholder);
export default __webpack_public_path__ + "static/media/course-placeholder.23a7b4a2772c96de75f45f12deee7cf5.svg";
export { ForwardRef as ReactComponent };